import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsSlidingNavModule } from '@lcs/shared/sliding-nav';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AvatarModule } from 'src/app/common-components/avatar/avatar.module';
import { GlobalSearchModule } from 'src/app/common-components/global-search/global-search.module';
import { NdtLogoModule } from 'src/app/common-components/ndt-logo/ndt-logo.module';
import { RouteAreaActiveModule } from 'src/app/router/route-area-active/route-area-active.module';
import { SiteLayoutComponent } from './containers/site-layout.component';
import { NestedMenuComponent } from './site-menu/nested-menu.component';
import { SiteMenuComponent } from './site-menu/site-menu.component';
import { SiteSidenavContentComponent } from './site-sidenav-content/site-sidenav-content.component';
import { SiteLayoutEffects } from './state/site-layout.effects';
import { siteLayoutReducer, siteLayoutReducerKey } from './state/site-layout.reducer';
import { SiteLayoutViewComponent } from './views/site-layout-view.component';

@NgModule({
   declarations: [
      SiteLayoutComponent,
      SiteLayoutViewComponent,
      SiteMenuComponent,
      SiteSidenavContentComponent,
      NestedMenuComponent,
   ],
   imports: [
      CommonModule,
      OverlayModule,
      FormsModule,
      LcsSlidingNavModule,
      MatButtonModule,
      MatDividerModule,
      MatIconModule,
      MatFormFieldModule,
      MatInputModule,
      MatMenuModule,
      MatSidenavModule,
      MatTooltipModule,
      MatSlideToggleModule,
      AvatarModule,
      PortalModule,
      ReactiveFormsModule,
      RouteAreaActiveModule,
      GlobalSearchModule,
      RouterModule,
      ScrollingModule,
      NdtLogoModule,
      EffectsModule.forFeature([SiteLayoutEffects]),
      StoreModule.forFeature(siteLayoutReducerKey, siteLayoutReducer),
   ],
})
export class SiteLayoutModule {}
